const TOKEN_KEY = "gentle_renters_admin_token";
const USER_KEY = "gentle_renters_admin_user";
const SESSION_EXPIRED_KEY = "gentle_renters_admin_session_expired";

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY) || "";

export const getAdminUser = () => {
  const raw = localStorage.getItem(USER_KEY);

  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
};

export const persistAdminSession = (payload) => {
  if (payload?.token) {
    localStorage.setItem(TOKEN_KEY, payload.token);
  }

  if (payload?.user) {
    localStorage.setItem(USER_KEY, JSON.stringify(payload.user));
  }
};

export const clearAdminSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

export const setSessionExpiredNotice = (message = "Your login session has expired. Please sign in again.") => {
  sessionStorage.setItem(SESSION_EXPIRED_KEY, message);
};

export const getSessionExpiredNotice = () => sessionStorage.getItem(SESSION_EXPIRED_KEY) || "";

export const consumeSessionExpiredNotice = () => {
  const message = getSessionExpiredNotice();

  if (message) {
    sessionStorage.removeItem(SESSION_EXPIRED_KEY);
  }

  return message;
};

export const isAdminRole = (role) => ["super_admin", "staff", "support_admin", "stockkeeper", "business_manager"].includes(role);
export const isSuperAdmin = (role) => role === "super_admin";
export const isSupportAdmin = (role) => role === "support_admin" || role === "business_manager";
export const canAccessDashboard = (role) => isAdminRole(role);
export const canAccessQuotations = (role) => isAdminRole(role);
export const canAccessSales = (role) => isSuperAdmin(role);
export const canAccessUsers = (role) => isAdminRole(role);
export const canAccessMessages = (role) => ["super_admin", "support_admin", "business_manager"].includes(role);
export const canAccessProducts = (role) => isSuperAdmin(role);
export const canAccessAdmins = (role) => isSuperAdmin(role);
export const canAccessAbout = (role) => isSuperAdmin(role);
export const canAccessSettings = (role) => isSuperAdmin(role);
export const canCreateUsers = (role) => isSuperAdmin(role);
export const canEditUsers = (role) => ["super_admin", "support_admin", "business_manager"].includes(role);
export const canDeleteUsers = (role) => isSuperAdmin(role);
export const canSuspendUsers = (role) => ["super_admin", "staff", "support_admin", "stockkeeper", "business_manager"].includes(role);
